import { atomWithReset } from 'jotai/utils';
export const drawerAtom = atomWithReset<{
  isOpen: boolean;
  title: string;
  descriptionComponent: () => React.ReactNode;
  component: () => React.ReactNode;
}>({
  isOpen: false,
  title: '',
  descriptionComponent: () => null,
  component: () => null
});